/*
 *
 *  * Copyright(c) 2022 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { StudyDataAccessor } from '@app/di/channel/fhircast/model/study-data-accessor';

/**
 * @author 212767271 Peter Szanka
 */
export class WorkItemDataAccessor implements StudyDataAccessor {
  accessionNumber: string;
  description: string;
  internalId: string;
  isRelevant: boolean; // not exits for primary study
  mrn: string;
  numberOfInstances: number;
  numberOfSeries: number;
  started: string;
  uid: string;

  constructor(workItem: any) {
    if (!workItem) {
      return;
    }

    this.accessionNumber = workItem.procedureAccessionNo;
    this.description = '';
    this.internalId = workItem.id;
    this.mrn = workItem.mrn ? workItem.mrn[0]?.value : undefined;
    this.numberOfInstances = workItem.imageCount;
    this.numberOfSeries = workItem.numberOfSeries;
    this.started = workItem.timeOfExam;
    if (workItem.source === 'patient-history') {
      this.uid = workItem.studyLevelStudyInstanceUID;
    } else {
      this.uid = workItem.procedureStudyInstanceUID;
    }
  }
}
